<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar class="w-100">
                    <router-link :to="{
                        name: 'users_details',
                        params: {
                            hashid: contract.user_id
                        }
                    }">{{ contract.user_full_name }}</router-link>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <form class="kt-form" @submit.prevent="create($event, contract)">
                    <kt-form-section class="row">
                        <kt-form-group class="col-4">
                            <kt-form-label for="contract_title">
                                {{ $t('online_contract.contract_type') }}
                            </kt-form-label>
                            <input type="text" :disabled="checkEnableEdit" v-model="contract.contract_title"
                                name="contract_title" id="contract_title" class="form-control">
                        </kt-form-group>
                        <kt-form-group class="col-4">
                            <kt-form-label for="payment_status">
                                {{ $t('online_contract.payment_status_title') }}
                            </kt-form-label>
                            <select id="payment_status" class="form-control kt-selectpicker" name="payment_status"
                                :disabled="checkEnableEdit" v-model="contract.payment_status">
                                <option v-bind:key="index" v-for="(item, index) in paymentStatus" v-bind:value="item">
                                    {{ paymentStatusStr.get(item) }}
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-group class="col-4">
                            <kt-form-label for="sign_type">
                                {{ $t('online_contract.sign_type') }}
                            </kt-form-label>
                            <select id="sign_type" class="form-control kt-selectpicker" name="sign_type"
                                v-model="contract.sign_type">
                                <option v-bind:key="index" v-for="(item, index) in signType" v-bind:value="item">
                                    {{ signTypeStr.get(item) }}
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-group class="col-4">
                            <kt-form-label for="end_at">
                                {{ $t('online_contract.price') }}
                            </kt-form-label>
                            <amount-input :disabled="checkEnableEdit" :item_id="`amount`" :item_name="`amount`"
                                :item="price"></amount-input>
                        </kt-form-group>

                        <kt-form-group class="col-4">
                            <kt-form-label for="start_at">
                                {{ $t('online_contract.start_at') }}
                            </kt-form-label>
                            <datePicker id="start_at" name="start_at" :disabled="checkEnableEdit" format="YYYY-MM-DD"
                                display-format="dddd jDD jMMMM jYYYY" input-class="form-control"
                                v-model="contract.start_at" type="date" />
                        </kt-form-group>
                        <kt-form-group class="col-4">
                            <kt-form-label for="end_at">
                                {{ $t('online_contract.end_at') }}
                            </kt-form-label>
                            <datePicker id="end_at" name="end_at" format="YYYY-MM-DD" :disabled="checkEnableEdit"
                                display-format="dddd jDD jMMMM jYYYY" input-class="form-control"
                                v-model="contract.end_at" type="date" />
                        </kt-form-group>
                    </kt-form-section>
                    <kt-form-group>
                        <kt-form-label for="content">
                            {{ $t('online_contract.content') }}
                        </kt-form-label>

                        <ckeditor :editor="editor" :disabled="checkEnableEdit" id="content" name="content"
                            v-model="contract.contract_content" :config="editorConfig" tag-name="content">
                        </ckeditor>
                    </kt-form-group>


                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_button">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import { onlineContractService } from '@/common/api.service'
import AmountInput from "@/components/custom-elements/amount-input.vue"
import MainContent from "@/components/main-content.vue"
import { editorConfig } from '@/constants/ckeditorConfigs'
import { contractStatus } from "@/constants/onlineContract"
import { signType, signTypeStr } from "@/constants/onlineContractSignType"
import { paymentStatus, paymentStatusStr } from "@/constants/PaymentStatus"
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { i18n } from "@/plugins/i18n"
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor"
import CKEditor from '@ckeditor/ckeditor5-vue2'
import $ from 'jquery'


export default {
    name: 'update-contract',
    computed: {
        checkEnableEdit() {
            return this.contract.status !== contractStatus.PENDING
                || this.contract.payment_status === paymentStatus.PAID;
        },
        paymentStatus() {
            return paymentStatus;
        },
        paymentStatusStr() {
            return paymentStatusStr;
        },
        signType() {
            return signType;
        },
        signTypeStr() {
            return signTypeStr;
        },
    },

    components: {
        MainContent,
        AmountInput,
        ckeditor: CKEditor.component
    },
    data() {
        return {
            query: {},
            editorConfig: editorConfig,
            editor: ClassicEditor,
            contract: {},
            price: {
                amount: 0
            },

        }
    },
    methods: {
        create(e, query) {
            let form = $(e.target)
            let btn = $('#submit_button')

            form.validate({
                ignore: ":hidden",

                rules: {
                    hashid: {
                        required: true,
                    },
                    payment_status: {
                        required: true,
                    },
                    start_at: {
                        required: true,
                    },
                    end_at: {
                        required: true,
                    },
                    content: {
                        required: true,
                    },
                    sign_type: {
                        required: true,
                    },
                },
            });


            if (!form.valid()) {
                return
            }

            let params = {
                title: query.contract_title,
                content: query.contract_content,
                start_at: query.start_at,
                end_at: query.end_at,
                sign_type: query.sign_type,
                payment_status: query.payment_status,
                created_for: this.$route.params.hashid,
                price: this.price.amount,
            }

            KTApp.progress(btn)
            onlineContractService.contractUpdate(this.$route.params.hashid, params)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({ response }) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                    KTApp.unprogress(btn)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
        getContractList() {
            onlineContractService.findContract(this.$route.params.hashid)
                .then(({ data }) => {
                    this.contract = data.data;
                    this.price.amount = data.data.price;
                })
        },
        setContent(event) {

            let content = this.templates.find(item => {
                if (item.hashid === event.target.value) {
                    return item;
                }
            })
            this.query.content = content.content;
            this.query.title = content.title;
        },

        reloadSelector() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 2,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            }, 1000);
        }
    },

    mounted() {
        this.getContractList();
        this.reloadSelector();
    }
}
</script>

<style></style>